import { Badge } from "@/components/ui/Badge";
import {
  MPZP_ORDER_STATUS_COLORS,
  MPZP_ORDER_STATUS_LABELS,
  type MpzpOrderStatus,
} from "../../types";

export function MpzpStatusBadge({ status }: { status: MpzpOrderStatus }) {
  return (
    <Badge color={MPZP_ORDER_STATUS_COLORS[status] ?? "gray"}>
      {MPZP_ORDER_STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
